<div class="DayCell">
  <span>
    {{ singleDay?.dayOfTheMonth }}
  </span>

  @for (data of singleDay.data; track data) {
    <span class="DayCell__StatusPillContainer">
      <status
        class="DayCell__StatusPill"
        [config]="{
          label: data.claim_type,
          matchColor: data.claim_status,
          capitalized: true,
          statuses: statusses,
        }"
        (click)="statusPillClicked.emit(data)"
      >
      </status>
    </span>
  }
</div>
